import React from "react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const hospitalityData = {
  badge: "Restro One AI",
  title: "Hospitality & Restaurant AI",
  industry: "Hospitality",
  tagline: "Never miss a booking, a call, or a customer again with AI-powered hospitality operations.",
  image: "https://images.pexels.com/photos/29870245/pexels-photo-29870245.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  cta: "Explore Restaurant Platform",
  stats: [
    { number: "60%", label: "More Bookings" },
    { number: "0", label: "Missed Calls" },
    { number: "45%", label: "Higher Repeat Visits" },
    { number: "24/7", label: "Automated Operations" },
  ],
  problems: [
    {
      title: "Missed Reservations & Calls",
      desc: "Busy staff miss calls and booking requests, leading to lost revenue and frustrated customers.",
    },
    {
      title: "Manual Ordering Processes",
      desc: "Phone and in-person orders create bottlenecks, errors, and inefficiencies during peak hours.",
    },
    {
      title: "Low Repeat Customer Rate",
      desc: "Without proactive engagement, customers don't return — loyalty is left entirely to chance.",
    },
    {
      title: "Staff Overwhelm at Peak Hours",
      desc: "Peak hour rushes overwhelm front-of-house staff, degrading the customer experience.",
    },
  ],
  solutions: [
    {
      title: "AI Reservation Agents",
      desc: "Automated reservation system that handles bookings, modifications, and confirmations 24/7.",
    },
    {
      title: "AI Voice Receptionist",
      desc: "Human-like AI voice agent that answers every call, handles queries, and books reservations.",
    },
    {
      title: "WhatsApp Ordering Systems",
      desc: "Complete ordering experience on WhatsApp — menus, customizations, payment, and status updates.",
    },
    {
      title: "CRM & Loyalty Automation",
      desc: "Automated customer profiles, birthday offers, re-engagement campaigns, and loyalty programs.",
    },
  ],
  outcome:
    "Increase bookings by 60%, eliminate missed calls entirely, and build a loyal customer base with automated CRM that keeps guests coming back. Transform your restaurant operations so your team focuses on exceptional hospitality — not paperwork.",
};

const HospitalityPage = () => <IndustryPageTemplate data={hospitalityData} />;

export default HospitalityPage;
